module.exports = __webpack_public_path__ + "img/notification-comment.89c5af9c.svg";